var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61598 1.61599C1.85039 1.38165 2.16828 1.25 2.49973 1.25C2.83119 1.25 3.14907 1.38165 3.38348 1.61599L9.99973 8.23223L16.616 1.61599C16.7313 1.4966 16.8692 1.40137 17.0217 1.33586C17.1742 1.27035 17.3383 1.23586 17.5042 1.23442C17.6702 1.23298 17.8348 1.26461 17.9884 1.32746C18.142 1.39031 18.2816 1.48313 18.399 1.60049C18.5163 1.71786 18.6092 1.85742 18.672 2.01104C18.7349 2.16466 18.7665 2.32926 18.765 2.49524C18.7636 2.66121 18.7291 2.82524 18.6636 2.97774C18.5981 3.13025 18.5029 3.26818 18.3835 3.38349L11.7672 9.99973L18.3835 16.616C18.6112 16.8517 18.7372 17.1675 18.7343 17.4952C18.7315 17.823 18.6 18.1365 18.3683 18.3683C18.1365 18.6 17.823 18.7315 17.4952 18.7343C17.1675 18.7372 16.8517 18.6112 16.616 18.3835L9.99973 11.7672L3.38348 18.3835C3.14773 18.6112 2.83198 18.7372 2.50423 18.7343C2.17649 18.7315 1.86297 18.6 1.63121 18.3683C1.39945 18.1365 1.26799 17.823 1.26514 17.4952C1.26229 17.1675 1.38829 16.8517 1.61598 16.616L8.23223 9.99973L1.61598 3.38349C1.38164 3.14908 1.25 2.83119 1.25 2.49974C1.25 2.16828 1.38164 1.85039 1.61598 1.61599Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtnIcon);
export default __webpack_public_path__ + "static/media/CloseBtnIcon.645c39387ef27d8732c4f41ba5d3af3c.svg";
export { ForwardRef as ReactComponent };